
import { defineComponent } from "vue";

export default defineComponent({
  name: "genealogy-table",
  props: {
    data: { type: Array, required: true },
  },
  emits: ["navigate"],
  methods: {
    capitalizeName(name: string): string {
      if (!name) return "";
      return String(name).toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    },
    formatUsid(usid: string): string {
      if (!usid) return "";
      return String(usid).toUpperCase();
    },
    isPpsPackageType(desc: string): boolean {
      return String(desc || "").trim().toUpperCase() === "PPS";
    },
    navigateToUser(usid: string) {
      if (!usid) return;
      this.$emit("navigate", usid);
    },
  },
});
